import _ from 'helpers/no_conflict_lodash';
import { presentValueOrDefault } from 'helpers/string_helpers';
import { TASK_TYPES, VIEW_TASKS_LIST, VIEW_TASKS_PROJECTS } from 'helpers/tasks/constants';

import {
  changeAssigneeFilter,
  changeCreatorFilter,
  changeEndDateFilter,
  changeSearchText,
  changeStartDateFilter,
  changeStatusFilter,
  changeTagsFilter,
  changeTaskTypeFilter,
  resetAssigneeFilter,
  toggleIncludeUntagged
} from './actions/query';

import { changeTasksView } from './actions/ui';
import { stringToArray, arrayToString } from 'helpers/formatters/string_formats';

function stringToUserId(value) {
  if (value == null || value === '') {
    return undefined; // Stand-in for 'current user'
  } else if (value === 'all') {
    return null;
  } else {
    return Number.parseInt(value);
  }
}

function userIdToString(value) {
  if (value === undefined) {
    return '';
  } else if (value === null) {
    return 'all';
  } else {
    return value.toString();
  }
}

const queryParams = {
  assignee: {
    action: value => value === undefined ? resetAssigneeFilter() : changeAssigneeFilter(value),
    selector: state => state.query.assigneeId,
    stringToValue: stringToUserId,
    valueToString: userIdToString
  },
  createdBy: {
    action: changeCreatorFilter,
    selector: state => state.query.creatorId,
    stringToValue: stringToUserId,
    valueToString: userIdToString
  },
  from: {
    action: value => changeStartDateFilter(value),
    defaultValue: null,
    selector: state => state.query.startDate,
    stringToValue: value => presentValueOrDefault(value, null),
    valueToString: value => presentValueOrDefault(value, '')
  },
  q: {
    action: changeSearchText,
    defaultValue: '',
    selector: state => state.query.searchText,
    stringToValue: value => presentValueOrDefault(value, ''),
    valueToString: value => presentValueOrDefault(value, '')
  },
  to: {
    action: changeEndDateFilter,
    defaultValue: null,
    selector: state => state.query.endDate,
    stringToValue: value => presentValueOrDefault(value, null),
    valueToString: value => presentValueOrDefault(value, '')
  },
  status: {
    action: changeStatusFilter,
    defaultValue: 'not_completed',
    selector: state => state.query.status,
    stringToValue: (value) => {
      if (value == null) return 'not_completed';
      if (value === 'all') return 'all';
      return value;
    },
    valueToString: (value) => {
      if (value == null) return 'all';
      if (value === 'not_completed') return null;
      return value;
    }
  },
  type: {
    action: changeTaskTypeFilter,
    defaultValue: null,
    selector: state => state.query.taskType,
    stringToValue: value => _.get(TASK_TYPES, [value, 'value']),
    valueToString: value => value ? _.findKey(TASK_TYPES, option => option.value === value) : null
  },
  view: {
    action: view => changeTasksView(view || VIEW_TASKS_LIST),
    selector: state => state.ui.activeView,
    stringToValue: (view) => {
      if (view === 'chronological') {
        return VIEW_TASKS_LIST;
      } else {
        return VIEW_TASKS_PROJECTS;
      }
    },
    valueToString: (view) => {
      switch (view) {
      case VIEW_TASKS_LIST:
        return 'chronological';
      case VIEW_TASKS_PROJECTS:
        return 'projects';
      }
    }
  },
  tags: {
    action: changeTagsFilter,
    defaultValue: [],
    selector: state => state.query.tagIds || [],
    stringToValue: stringToArray,
    valueToString: arrayToString
  },
  includeUntagged: {
    action: toggleIncludeUntagged,
    defaultValue: false,
    selector: state => state.query.includeUntagged
  },
};

export default queryParams;
